<template>
  <div
    v-if="workspace"
    :class="['material-panel', {'onair': workspace.onair}]"
    >
    <div class="head">
      <div class="title">
        素材一覧
      </div>
      <div class="setting">
        <Button
          size="small"
          icon="md-image"
          class="appearance-button"
          @click="savePreviousWorkspaceId(workspace.id)"
          :to="'/fixed-journals/'+workspace.channel_id"
        >
          定型文の管理
        </Button>
      </div>
      <div class="setting">
        <Button
          type="primary"
          size="small"
          icon="md-image"
          class="appearance-button"
          @click="materialAppearanceModal.show = true"
          v-if="workspace.config.use_material_appearance"
        >
          L字デザインの変更
        </Button>
      </div>
    </div>
    <div class="content">
      <div
        class="category-block"
        v-for="materialCategory in materialCategories"
        :key="materialCategory.id">
        <h4 class="title">
          <Dropdown
            placement="right-start"
            v-if="isWritable(workspace.channel_id)"
            @on-click="handleMaterialCategoryAction(materialCategory.id, $event)">
            {{ materialCategory.name }}
            <Icon type="ios-arrow-down" />
            <DropdownMenu slot="list">
              <DropdownItem
                name="updateMaterialCategory"
                v-if="isManageable(workspace.channel_id)">
                素材カテゴリーを編集
              </DropdownItem>
              <DropdownItem
                name="deleteMaterialCategory"
                v-if="isManageable(workspace.channel_id)">
                素材カテゴリーを削除
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </h4>
        <MaterialGroup
          v-for="materialGroup in orderMaterialGroups(materialCategory.material_groups)"
          v-if="materialGroup.material_type.capacity !== null"
          :key="materialGroup.id"
          :parentMaterialGroup="materialGroup"
          :parentMaterialList="materials.filter(i => i.material_group_id == materialGroup.id).sort((i, j) => i.order - j.order)"
          :workspace="workspace"
          :isWritable="isWritable(workspace.channel_id)"
          :sortableLock="sortableLock"
          :setSortableLock="setSortableLock"
        />
      </div>
      <Button
        long
        v-if="isManageable(workspace.channel_id)"
        @click="materialCategoryCreateModal.show = true"
        >
        素材カテゴリーを追加
      </Button>
    </div>
    <div class="bottom">
      <Button
        ghost
        v-if="isWritable(workspace.channel_id) && !workspace.onair"
        icon="md-play"
        type="primary"
        @click="onair"
        class="onair-button"
      >
        連携開始
      </Button>
      <Button
        ghost
        v-if="isWritable(workspace.channel_id) && workspace.onair"
        icon="md-pause"
        type="primary"
        @click="standbyModal.show = true"
        class="onair-button"
      >
        連携停止
      </Button>
    </div>
    <Modal
      :closable="false"
      footer-hide
      v-model="materialCategoryCreateModal.show"
    >
      <div>
        <Form :model="materialCategoryCreateModal.data">
          <FormItem label="素材カテゴリー名">
            <Input v-model="materialCategoryCreateModal.data.name"></Input>
          </FormItem>
          <FormItem label="原稿のジャンルを選択">
            <CheckboxGroup
              v-model="materialCategoryCreateModal.data.categories"
              >
              <Checkbox label="railway">鉄道</Checkbox>
              <Checkbox label="airway">空の便</Checkbox>
              <Checkbox label="road">道路</Checkbox>
              <Checkbox label="bus">バス</Checkbox>
              <Checkbox label="ferry">船舶</Checkbox>
              <Checkbox label="lifeline">ライフライン</Checkbox>
              <Checkbox label="weather">気象情報</Checkbox>
              <Checkbox label="evacuation">避難情報</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <a @click="materialCategoryCreateModal.showDetail = true" v-if="!materialCategoryCreateModal.showDetail" style="width: 100%; display: inline-block; text-align: center">詳細設定を表示▼</a>
          <div v-if="materialCategoryCreateModal.showDetail">
            <FormItem label="素材タイプを選択">
              <CheckboxGroup
                v-model="materialCategoryCreateModal.data.types"
                >
                <Checkbox v-for="i in materialTypes" :label="i.id" :key="i.id">{{ i.name }}</Checkbox>
              </CheckboxGroup>
            </FormItem>
            <a @click="materialCategoryCreateModal.showDetail = false" style="width: 100%; display: inline-block; text-align: center">詳細設定を隠す▲</a>
          </div>
        </Form>
        <div>
          <Button type="primary" @click="createMaterialCategory" style="float: right">追加</Button>
          <Button @click="materialCategoryCreateModal.show = false">キャンセル</Button>
        </div>
      </div>
    </Modal>
    <Modal
      :closable="false"
      footer-hide
      v-model="materialCategoryUpdateModal.show"
    >
      <div>
        <Form :model="materialCategoryUpdateModal.data">
          <FormItem label="素材カテゴリー名">
            <Input v-model="materialCategoryUpdateModal.data.name"></Input>
          </FormItem>
        </Form>
        <div>
          <Button type="primary" @click="updateMaterialCategory" style="float: right">更新</Button>
          <Button @click="materialCategoryUpdateModal.show = false">キャンセル</Button>
        </div>
      </div>
    </Modal>
    <Modal
      :closable="false"
      footer-hide
      v-model="materialGroupCreateModal.show"
    >
      <div>
        <Row>
          <Col span="24">
            <Form :model="materialGroupCreateModal.data">
              <FormItem label="素材部品名">
                <Select v-model="materialGroupCreateModal.data.material_type_id" placeholder="部品を選んでください">
                    <Option v-for="i in materialTypes" :value="i.id" :key="i.id">{{ i.name }}</Option>
                </Select>
              </FormItem>
              <FormItem label="キャパシティ">
                <Input v-model="materialGroupCreateModal.data.capacity" placeholder="1以上の数字を入力"></Input>
              </FormItem>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col span=24>
            <Button type="text" @click="materialGroupCreateModal.show = false; materialGroupCreateModal.data.material_category_id = null; materialGroupCreateModal.data.material_type_id = null; materialGroupCreateModal.data.capacity = null">キャンセル</Button>
            <Button type="primary" style="float: right" @click="createMaterialGroup">追加する</Button>
          </Col>
        </Row>
      </div>
    </Modal>
    <Modal
      :closable="false"
      footer-hide
      v-model="standbyModal.show"
    >
      <div>
        <Row>
          <Col span="24">
            <p style="padding: 1em 1em 3em; font-weight: bold; vertical-align: middle; font-size: 15px; line-height: 24px">
              <Icon type="md-information-circle" size="24" />
              <template v-if="!!workspace.config.workspace_standby_confirm_msg">{{ workspace.config.workspace_standby_confirm_msg }}</template>
              <template v-else>連携を解除します。よろしいですか？</template> 
            </p>
          </Col>
        </Row>
        <Row>
          <Col span=24>
            <Button type="text" @click="standbyModal.show = false">キャンセル</Button>
            <Button type="error" style="float: right" @click="standby">停止する</Button>
          </Col>
        </Row>
      </div>
    </Modal>
    <Modal
      footer-hide
      v-model="materialAppearanceModal.show"
      width="90%"
    >
      <div style="padding-top: 32px;">
        <Row>
          <Col span="6" v-for="i in materialAppearances" :key="i.id">
            <template v-if="i.id.startsWith('abema-') || i.id.startsWith('blue-') || (i.id.startsWith('red-') && isManageable(workspace.channel_id))">
              <div v-if="(!!materialAppearanceModal.selected ? materialAppearanceModal.selected : workspace.config.material_appearance_id) == i.id">
                <Badge :offset="[10, 18]" style="border: 5px solid #ed4014; display: block; user-select: none;">
                  <img :src="i.thumbnail_url" style="width: 100%; display: block" />
                  <Icon type="md-checkmark-circle" slot="count" color="#ed4014" size="32" />
                </Badge>
              </div>
              <div v-else>
                <div style="padding: 5px; user-select: none;" @click="materialAppearanceModal.selected = i.id">
                  <img :src="i.thumbnail_url" style="width: 100%; display: block; cursor: pointer" />
                </div>
              </div>
            </template>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <Button
              type="primary"
              :disabled="!(!!materialAppearanceModal.selected && workspace.config.material_appearance_id != materialAppearanceModal.selected)"
              @click="updateMaterialAppearance(materialAppearanceModal.selected)">決定</Button>
          </Col>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import MaterialGroup from './MaterialGroup.vue'

export default {
  components: {
    MaterialGroup
  },
  data() {
    return {
      materialCreateModal: {
        show: false, data: {material_group_id: null, journal_text: ""}
      },
      materialCategoryCreateModal: {
        show: false, showDetail: false, data: {id: null, name: null, categories: [], types: []}
      },
      materialCategoryUpdateModal: {
        show: false, data: {id: null, name: null}
      },
      materialGroupCreateModal: {
        show: false, data: {material_category_id: null, material_type_id: null, capacity: null}
      },
      standbyModal: {
        show: false
      },
      materialAppearanceModal: {
        show: false,
        selected: null
      },
      sortableLock: null
    }
  },
  methods: {
    ...mapActions({
      setJournalEditModalTarget: 'dashboard/setJournalEditModalTarget',
      setMaterialAppearanceModalTarget: 'dashboard/setMaterialAppearanceModalTarget',
      savePreviousWorkspaceId: 'fixedJournals/savePreviousWorkspaceId',
    }),
    orderMaterialGroups: function (materialGroups) {
      return _.orderBy(materialGroups, 'material_type.order')
    },
    onair() {
      this.$store.dispatch('onairWorkspace', this.workspace)
    },
    standby() {
      this.$store.dispatch('standbyWorkspace', this.workspace)
      this.standbyModal.show = false;
    },
    createMaterial() {
      this.$store.dispatch(
        'createMaterial', {
          ...this.page, 
          materialInput: {
            material_group_id: this.materialCreateModal.data.material_group_id,
            order: null,
            journal: {
              text: this.materialCreateModal.data.journal_text,
              meta: {}
            }
          }
        }
      ).then(() => {
        this.materialCreateModal.show = false
        this.materialCreateModal.data.material_group_id = null
        this.materialCreateModal.data.journal_text = ""
      })
    },
    showMaterialCreateModal(materialGroupId) {
      this.materialCreateModal.show = true
      this.materialCreateModal.data.material_group_id = materialGroupId
    },
    hideMaterial(materialId) {
      this.$store.dispatch('hideMaterial', {...this.page, materialId})
    },
    showMaterial(materialId) {
      this.$store.dispatch('showMaterial', {...this.page, materialId})
    },
    moveupMaterial(materialId) {
      this.$store.dispatch('moveupMaterial', {...this.page, materialId})
    },
    movedownMaterial(materialId) {
      this.$store.dispatch('movedownMaterial', {...this.page, materialId})
    },
    deleteMaterial(materialId) {
      this.$store.dispatch('deleteMaterial', {...this.page, materialId})
    },
    async createMaterialCategory() {
      const materialCategoryId = Math.random().toString(36).substring(2,7)
      await this.$store.dispatch(
        'createMaterialCategory', {
          ...this.page, 
          materialCategoryInput: {
            id: materialCategoryId,
            name: this.materialCategoryCreateModal.data.name,
            meta: {
              categories: this.materialCategoryCreateModal.data.categories.length > 0 ? this.materialCategoryCreateModal.data.categories.join(',') : '*',
            }
          }
        }
      )

      for (const materialTypeId of this.materialCategoryCreateModal.data.types) {
        await this.$store.dispatch(
          'createMaterialGroup', {
            ...this.page,
            materialGroupInput: {
              material_category_id: materialCategoryId,
              material_type_id: materialTypeId,
            }
          }
        )
      }

      this.materialCategoryCreateModal.show = false
      this.materialCategoryCreateModal.data.name = null
      this.materialCategoryCreateModal.data.categories = []
      this.materialCategoryCreateModal.data.types = this.defaultMaterialTypes

      window.location.reload()
    },
    updateMaterialCategory() {
      this.$store.dispatch(
        'updateMaterialCategory', {
          ...this.page, 
          materialCategoryId: this.materialCategoryUpdateModal.data.id,
          materialCategoryInput: {
            name: this.materialCategoryUpdateModal.data.name
          }
        }
      ).then(() => {
        this.materialCategoryUpdateModal.show = false
        this.materialCategoryUpdateModal.data.id = null
        this.materialCategoryUpdateModal.data.name = null
      })
    },
    deleteMaterialCategory(materialCategoryId) {
      this.$store.dispatch('deleteMaterialCategory', {...this.page, materialCategoryId})
    },
    createMaterialGroup() {
      this.$store.dispatch(
        'createMaterialGroup', {
          ...this.page, 
          materialGroupInput: this.materialGroupCreateModal.data
        }
      ).then(() => {
        this.materialGroupCreateModal.show = false
        this.materialGroupCreateModal.data.material_category_id = null
        this.materialGroupCreateModal.data.material_type_id = null
        this.materialGroupCreateModal.data.capacity = null
      })
    },
    handleMaterialCategoryAction(materialCategoryId, action) {
      if (action == 'createMaterialGroup') {
        this.materialGroupCreateModal.show = true
        this.materialGroupCreateModal.data.material_category_id = materialCategoryId
      } else if (action == 'updateMaterialCategory' ) {
        this.materialCategoryUpdateModal.show = true
        this.materialCategoryUpdateModal.data.id = materialCategoryId
        this.materialCategoryUpdateModal.data.name = this.getMaterialCategory(materialCategoryId).name
      } else if (action == 'deleteMaterialCategory') {
        this.$store.dispatch(
          'deleteMaterialCategory', {
            ...this.page, 
            materialCategoryId: materialCategoryId
          }
        )
        window.location.reload()
      }
    },
    setSortableLock(materialGroupId) {
      this.sortableLock = materialGroupId
    },
    async updateMaterialAppearance(materialAppearanceId) {
      await this.$store.dispatch('setWorkspaceConfig', {
        ...this.$route.params,
        key: 'material_appearance_id',
        value: materialAppearanceId
      })
      this.materialAppearanceModal.show = false
      this.$Message.info('デザイン変更を開始しました');
    }
  },
  computed: {
    ...mapGetters([
      'getWorkspace',
      'isWritable',
      'isManageable',
      'materialCategories',
      'materialTypes',
      'materialAppearances',
      'materials',
      'getMaterialCategory',
      'getMaterialAppearance',
    ]),
    page() {
      return this.$route.params
    },
    workspace() {
      return this.getWorkspace(this.page)
    },
    defaultMaterialTypes() {
      if (!!this.workspace.config.default_material_types && this.workspace.config.default_material_types.length > 0) {
        return this.workspace.config.default_material_types.concat()
      } else {
        return []
      }
    }
  },
  watch: {
    workspace() {
      this.materialCategoryCreateModal.data.types = this.defaultMaterialTypes
    }
  }
};
</script>

<style lang="less" scoped>
.material-panel {
  min-width: 360px;
  position: relative;
  height: 100%;
  background-color: #f8f8f9;

  .head {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    padding: 8px 8px;
    color: #fff;
    background: #0f4471;
    user-select: none;
    z-index: 10;

    .title {
      float: left;
      font-size: 16px;
      font-weight: bold;
      padding: 0 8px;
    }

    .setting {
      float: right;

      button {
        padding: 0 20px;
        font-weight: bold;
        font-size: 12px;
        
        i {
          padding: 0 0 2px;
          vertical-align: middle;
        }
      }
    }
  }

  .content {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 55px 10px 60px 10px;
    overflow-y: scroll;

    .category-block {
      margin-bottom: 24px;

      .title {
        border-left: 4px solid #0f4471;
        padding: 0 4px 0;
        margin-bottom: 6px;
        margin-left: 2px;
        font-size: 14px;
        line-height: 14px;
        cursor: pointer;
      }
    }

    .material-group-action {
      button {
        font-size: 11px !important;
      }
    }
  }

  .bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 46px;
    padding: 8px;
    z-index: 20;
    background: #0f4471;

    .onair-button {
      padding: 5px 30px 6px;
      color: #fff;
    }
  }
}

.onair {
  .head { background: #e03618 !important; }
  .bottom { background: #e03618 !important; }
  .content { .category-block { .title { border-color: #e03618 !important; } } }
}
</style>

<style lang="less">
.material-panel .content .material-block .ivu-table-row td {
  border-right: none;
}
.material-panel .bottom {
  .ivu-btn {
    color: #fff;
    font-weight: bold;
  }

  .ivu-btn-primary {
    border: 2px solid #fff;
  }

  .ivu-btn-primary:hover {
    color: #fff;
    border-color: #fff;
  }

  .ivu-btn:focus {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
}

</style>
